import React from 'react';
import { motion } from 'framer-motion';
const cases = [{
  icon: '👕',
  title: 'Marcas de ropa streetwear'
}, {
  icon: '🖨️',
  title: 'Print on Demand'
}, {
  icon: '🛍️',
  title: 'Tiendas online (Shopify, Etsy)'
}, {
  icon: '🎨',
  title: 'Diseñadores freelance'
}, {
  icon: '📦',
  title: 'Venta de productos digitales'
}, {
  icon: '📱',
  title: 'Creadores de contenido'
}];
export function UseCases() {
  return <section className="py-12 md:py-20 bg-neutral-950" data-id="element-158">
      <div className="container mx-auto px-4" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-160">
          <h2 className="font-bebas text-4xl md:text-5xl text-white uppercase tracking-wide" data-id="element-161">
            Utilizado en todo tipo de{' '}
            <span className="text-brand-500" data-id="element-162">modelos de negocio</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 max-w-5xl mx-auto" data-id="element-163">
          {cases.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 flex items-center gap-4 hover:border-brand-500/50 transition-colors group" data-id="element-164">
              <span className="text-4xl group-hover:scale-110 transition-transform" data-id="element-165">
                {item.icon}
              </span>
              <h3 className="text-lg font-semibold text-neutral-200" data-id="element-166">
                {item.title}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}